export function resetOptions(element, tomSelect) {
  const value = element.value

  const { options, optionGroups } = buildOptions(element, tomSelect.settings)

  tomSelect.clear(true)
  tomSelect.clearOptions()
  tomSelect.clearOptionGroups()
  tomSelect.setupOptions(options, optionGroups)
  tomSelect.setValue(value, true)
  tomSelect.refreshOptions(false)
  tomSelect.lastQuery = null
}

function buildOptions(element, tomSelectSettings) {
  const options = []
  const optionGroups = []

  let index = 1
  let order = 1
  Array.from(element.children).forEach((child) => {
    const tagName = child.tagName

    if (tagName === "OPTGROUP") {
      const optgroup = child

      optgroup[tomSelectSettings.optgroupValueField] = index
      optionGroups.push(optgroup)

      Array.from(optgroup.children).forEach((child) => {
        const option = child

        option[tomSelectSettings.optgroupField] = index

        option.$option = child
        option.$order = order

        options.push(option)

        order++
      })

      index++
    } else {
      const option = child

      if (option.value !== "") {
        option.$option = child
        option.$order = order

        options.push(option)

        order++
      }
    }
  })

  return {
    options,
    optionGroups
  }
}
